import { call, take, put } from 'redux-saga/effects';
import { post } from '../../utils/api';
import settings from '../../utils/settings';
import { BRANCH_LIST_REQUEST, BRANCH_LIST_SUCCESS, CREATE_BRANCH_REQUEST, REQUEST_FAILURE } from './constants';
import { REQUEST_FAILURE as COMPANY_REQUEST_FAILURE } from '../Layouts/constants';

export function* getBranchList() {
  while (true) {
    const request = yield take(BRANCH_LIST_REQUEST);
    try {
      let response;
      const { companyId, page, limit, company } = request.payload;
      if (company.country && company.country.text === 'all') company.country.text = '';
      response = yield call(post, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/company/${companyId}/branches`),
        body: { company, page, limit }
      });
      if (response.success) {
        const { result } = response;
        if (result !== []) {
          yield put({ type: BRANCH_LIST_SUCCESS, branchList: response.result });
        } else {
          yield put({ type: REQUEST_FAILURE, error: result.message });
        }
      }
    } catch (error) {
      console.log('Saga: getBranchList:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}

export function* createBranch() {
  while (true) {
    const request = yield take(CREATE_BRANCH_REQUEST);
    const { companyId, body, successCbk } = request.payload;
    try {
      let response;
      response = yield call(post, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/company/${companyId}/branches/create`),
        body
      });
      const { success, result } = response;
      if (success) {
        successCbk();
      } else {
        yield put({ type: COMPANY_REQUEST_FAILURE, error: result.message || result.messages });
      }
    } catch (error) {
      yield put({ type: COMPANY_REQUEST_FAILURE, error });
    }
  }
}
